/* unplugin-vue-components disabled */import script from "./Sidentify.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidentify.vue?vue&type=script&setup=true&lang=js"

import "./Sidentify.vue?vue&type=style&index=0&id=5777b054&scoped=true&lang=css"

import exportComponent from "D:\\WorkPlace\\官网\\html-bcepd-project-website-official-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5777b054"]])

export default __exports__